module.exports = __webpack_public_path__ + "img/fi-rr-plus-small.7aea4a46.svg";